import Pyramid from 'd3vue/components/Pyramid.vue'
import { keepDimensions, floatVal } from '../dataFilter'
import { toArray } from '../colors'
import api from '../api'

export default {
  id: 'pyramid',
  label: 'Graphique en Pyramide',
  component: Pyramid,
  dimensions: 2,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    const props = {}
    if (vue.colorScheme) {
      props.color = toArray(vue.colorScheme)[0]
    }
    vue.buildProps(props)
    const response = {}
    const lr = {}
    keepDimensions(2, data).forEach(d => {
      if (d.Group1UniqueName.substr(-3) === '[0]') {
        return
      }
      
      if (typeof lr.left === 'undefined') {
        lr.left = d.Group1UniqueName
      } else if (lr.left !== d.Group1UniqueName && typeof lr.right === 'undefined') {
        lr.right = d.Group1UniqueName
      }

      if (typeof response[d.Group0UniqueName] === 'undefined') {
        response[d.Group0UniqueName] = {
          label: d.Group0Caption,
          left: 0,
          right: 0
        }
      }

      if (lr.left === d.Group1UniqueName) {
        response[d.Group0UniqueName].left += floatVal(d, api.measure.name(vue.measure[0]))
        response[d.Group0UniqueName].leftLabel = d.Group1Caption
      } else if (lr.right === d.Group1UniqueName) {
        response[d.Group0UniqueName].right += floatVal(d, api.measure.name(vue.measure[0]))
        response[d.Group0UniqueName].rightLabel = d.Group1Caption
      }
    })
    
    return Object.keys(response).map(k => response[k])
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/Pyramid.js